import { noTagPage, getById } from '@/api/business/crmCustomerProject'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(noTagPage, getById)
